import React, { useEffect, useState } from 'react';
import { Spinner } from 'reactstrap';
import { getDashboardWorkOrderReporting } from '../../../../helpers/water_rights/backend_helper';
import EChartsStackedHorizontalBarChart from '../../../../Components/Common/Charts/ECharts/EChartsStackedHorizontalBarChart';
import { generateColorGradient } from '../../../../Components/Hooks/useColorArrayHooks';

const ReportabilityByCompanyChart = () => {
	const [series, setSeries] = useState([]);
	const [categories, setCategories] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		let cancelled = false;
		getDashboardWorkOrderReporting()
			.then(res => {
				if (!cancelled) {
					setCategories(res?.establishment_types || []);
					setSeries(res?.series || []);
				}
			})
			.catch(() => {})
			.finally(() => { if (!cancelled) setIsLoading(false); });
		return () => { cancelled = true; };
	}, []);

	if (isLoading) {
		return <div className='d-flex justify-content-center align-items-center py-4'><Spinner size='sm' /></div>;
	}

	if (!series.length) {
		return <div className='d-flex flex-column align-items-center justify-content-center text-muted py-4 h-100'><p className='mb-0'>Sin datos disponibles</p></div>;
	}

	return (
		<EChartsStackedHorizontalBarChart
			series={series}
			yAxisCategories={categories}
			colors={generateColorGradient(series.length || 1)}
			height='250px'
		/>
	);
};

export default ReportabilityByCompanyChart;
